import { render, staticRenderFns } from "./DraggableImages.vue?vue&type=template&id=1fbf8190&scoped=true&"
import script from "./DraggableImages.vue?vue&type=script&lang=ts&"
export * from "./DraggableImages.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableImages.vue?vue&type=style&index=0&id=1fbf8190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf8190",
  null
  
)

export default component.exports